export const menuTitle = { title: "JOB POSITION", label: "Job Position" }
  